"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.missedVisitFormToPayloadDataHandler = missedVisitFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function missedVisitFormToPayloadDataHandler(data) {
    var _a, _b, _c, _d, _e, _f;
    const now = (0, dayjs_1.default)();
    return Object.assign(Object.assign({}, (((_a = data === null || data === void 0 ? void 0 : data.futureAppointment) === null || _a === void 0 ? void 0 : _a.isConflictAllowed) && {
        isConflictAllowed: true,
    })), { form: Object.assign(Object.assign(Object.assign({ missedVisitDate: data.missedVisitDate, reason: data.reason, nextVisitDate: (_b = data.futureAppointment) === null || _b === void 0 ? void 0 : _b.visitDate }, (((_c = data.futureAppointment) === null || _c === void 0 ? void 0 : _c.visitStartTime) && {
            nextVisitStartTime: (_d = data.futureAppointment) === null || _d === void 0 ? void 0 : _d.visitStartTime,
        })), (((_e = data.futureAppointment) === null || _e === void 0 ? void 0 : _e.visitEndTime) && {
            nextVisitEndTime: (_f = data.futureAppointment) === null || _f === void 0 ? void 0 : _f.visitEndTime,
        })), { notes: data.notes, offSet: now.utcOffset() }) });
}
